import { Button, ColorPicker, Slider } from "antd";
import { memo, useState } from "react";
import { MdClose } from "react-icons/md";
import styled from "styled-components";

interface StyleFillProps {
    layer: any;
    onDeleted: () => void;
}
const StyleFill = (props: StyleFillProps) => {
    const [fillColor, setFillColor] = useState<string>(props.layer.paint['fill-color']);
    const [fillOpacity, setOpacity] = useState<number>(props.layer.paint['fill-opacity']);
    const [fillStrokeColor, setFillStrokeColor] = useState<string>('#fff');
    const [fillStrokeWidth, setFillStrokeWidth] = useState<number>(2);

    return <>
        <UI_Wrapper>
            <UI_Title_Wrapper>
                <UI_Content_Title>
                    {`Vùng (${props.layer['source-layer']})`}
                </UI_Content_Title>
                <Button type="text" style={{ padding: 8 }} onClick={() => {
                    props.onDeleted();
                    window.map?.removeLayer(props.layer.id);
                }}>
                    <MdClose color="red" />
                </Button>
            </UI_Title_Wrapper>

            <UI_Content_Row>
                <UI_Content_Row_Label>Màu vùng</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <ColorPicker
                        value={fillColor}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'fill-color', value.toHexString());
                            setFillColor(value.toHexString());
                        }}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>

            <UI_Content_Row>
                <UI_Content_Row_Label>Độ mờ đục (px)</UI_Content_Row_Label>
                <UI_Content_Row_Value>
                    <Slider
                        style={{ width: '100%' }}
                        value={fillOpacity}
                        onChange={(value) => {
                            window.map?.setPaintProperty(props.layer.id, 'fill-opacity', value);
                            setOpacity(value);
                        }}
                        step={0.01}
                        min={0}
                        max={1}
                    />
                </UI_Content_Row_Value>
            </UI_Content_Row>
        </UI_Wrapper>
    </>;
}

export default memo(StyleFill);

const UI_Wrapper = styled.div`
    padding: 8px;
`

const UI_Title_Wrapper = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`

const UI_Content_Title = styled.div`
    font-size: 13px;
    font-weight: 600;
    margin-right: 8px;
`

const UI_Content_Row = styled.div`
    display: flex;
    flex-direction: row;
    align-items: center;
    margin-bottom: 8px;
`
const UI_Content_Row_Label = styled.div`
    font-size: 14px;
    margin-right: 8px;
    color: #666666;
    flex: 1;
`
const UI_Content_Row_Value = styled.div`
    flex: 1;
`